import React from 'react';
import { ReactComponent as BreadcrumbDivider } from 'components/icons/forward.svg';
import { BreadcrumbWrapper } from './BreadcrumbStyles';

interface IProps {
  breadcrumb: string;
  onClickCallback: () => void;
}

export const Breadcrumb: React.FC<IProps> = (props) => {
  const { breadcrumb, onClickCallback } = props;
  return (
    <BreadcrumbWrapper onClick={onClickCallback}>
      <span data-testid={'breadcrumb-item'}>{breadcrumb}</span>
      <BreadcrumbDivider />
    </BreadcrumbWrapper>
  );
};
